import Action from "./comps/Action";
import Header from "./comps/Header";
import Price from "./comps/Price";
import Details from "./comps/Details";
import Text from "components/Table2/CellComps/Text";
import PriceComp from "components/Table2/CellComps/Price";
import { useSelector } from "react-redux";
import Box from "./comps/Box";
import Info from "./comps/Info";
import { SetStateAction, useEffect, useState } from "react";
import { apiGetFactor } from "../../../api/factorApi";
import { apiDeleteTransactions, apiGetTransaction } from "../../../api/transactionApi";
import { addOpenDrawer, setConfirm } from "../../../store/actions/appAction";
import { useNavigate } from "react-router-dom";
import EditImg from "assets/images/Edit.svg";
import DeleteImg from "assets/images/Delete.svg";
import {
  apiCreateNotifications,
  apiDeleteNotifications,
  apiEditNotifications,
  apiGetItemNotifications,
} from "api/notificationApi";
import { Tab, Tabs } from "@mui/material";
import { TabPanel } from "./FactorDrawer";
import DrawerHistory from "./comps/DrawerHistory";
import { apiGetHistory, apiGetItemNote } from "api/noteApi";
import { useAppDispatch } from "store/store";
import Table from "components/Table2";
import PrintTransaction from "./PrintTransaction";
import Button from "components/button/BasicButton";
import { Print } from "@mui/icons-material";

const initialTable: TableProps = {
  headers: [{ label: "نوع" }, { label: "عنوان" }, { label: "توضیحات" }, { label: "مبلغ" }],
  cols: [
    { Comp: Text, key: "type" },
    { Comp: Text, key: "label" },
    { Comp: Text, key: "description" },
    { Comp: PriceComp, key: "price" },
  ],
  headerColor: "#fff",
  rows: [],
  withoutMenu: true,
};

export default function TransactionDrawer() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { drawerProps, anchor } = useSelector((state: any) => state).appReducer;
  const token = useSelector((state: any) => state).businessReducer.business?.token;

  const [transaction, setTransaction] = useState(drawerProps?.transaction);
  const [table, setTable] = useState({
    source: initialTable,
    destination: initialTable,
  });

  useEffect(() => {
    if (transaction) {
      dispatch(
        apiGetTransaction(
          transaction.type_id ?? transaction.id,
          transaction.type,
          token,
          (transactionObject: any) => {
            if (transactionObject.transaction.Factor) {
              dispatch(
                apiGetFactor(
                  transactionObject.transaction.Factor.id,
                  transactionObject.transaction.Factor.type,
                  token,
                  (factor: any) => {
                    transactionObject.transaction.Factor = factor;

                    const newTransaction = {
                      ...transaction,
                      ...transactionObject.transaction,
                      Transaction_Items: transactionObject.transactionItems,
                    };
                    renderTable(newTransaction);
                    setTransaction(newTransaction);
                  }
                )
              );
            } else {
              const newTransaction = {
                ...transaction,
                ...transactionObject.transaction,
                Transaction_Items: transactionObject.transactionItems,
              };
              renderTable(newTransaction);
              setTransaction(newTransaction);
            }
          }
        )
      );
      initialNote();
    }
  }, []);

  // modal state
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const [notificationsList, setNotificationList] = useState([]);
  const [noteList, setNoteList] = useState([]);
  // ===modal state

  // notification functions
  const handleDeleteNotification = (id: any) => {
    dispatch(
      apiDeleteNotifications(token, id, () => {
        dispatch(
          apiGetItemNotifications(
            token,
            transaction.type_id ?? transaction.id,
            "Transaction",
            (value: SetStateAction<never[]>) => {
              setNotificationList(value);
            }
          )
        );
      })
    );
  };
  const handelChangeActive = (value: any) => {
    dispatch(
      apiEditNotifications(token, value?.id, value.active, () => {
        dispatch(
          apiGetItemNotifications(
            token,
            transaction.type_id ?? transaction.id,
            "Transaction",
            (value: SetStateAction<never[]>) => {
              setNotificationList(value);
            }
          )
        );
      })
    );
  };

  const submitNotification = (value: any) => {
    dispatch(
      apiCreateNotifications(
        token,
        transaction.type_id ?? transaction.id,
        "Transaction",
        value?.title,
        value?.description,
        value.fireDate,
        () => {
          dispatch(
            apiGetItemNotifications(
              token,
              transaction.type_id ?? transaction.id,
              "Transaction",
              (value: SetStateAction<never[]>) => {
                setNotificationList(value);
              }
            )
          );
          handleCloseModal();
        }
      )
    );
  };
  //=== notification functions

  // tabs state
  const [value, setValue] = useState(0);
  // ===state
  // tab function
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  //===========

  // ===transaction
  const [History, setHistory] = useState([]);

  // ===

  const initialNote = () => {
    dispatch(
      apiGetItemNote(
        token,
        transaction.type_id ?? transaction.id,
        "Transaction",
        (value: SetStateAction<never[]>) => {
          setNoteList(value);
        }
      )
    );
    dispatch(
      apiGetHistory(
        token,
        transaction.type_id ?? transaction.id,
        "Transaction",
        (value: SetStateAction<never[]>) => {
          setHistory(value);
        }
      )
    );
  };

  if (!transaction) return <></>;

  const closeDrawer = () => dispatch(addOpenDrawer(false, undefined, anchor));
  const editTransaction = () => {
    closeDrawer();
    navigate(`/transactions/${transaction.type}/${transaction.type_id ?? transaction.id}`);
  };

  const deleteTransaction = () => {
    closeDrawer();
    dispatch(
      setConfirm("حذف تراکنش", () =>
        dispatch(
          apiDeleteTransactions([transaction.type_id ?? transaction.id], token, { key: transaction.type })
        )
      )
    );
  };

  const actions = {
    menu: [
      {
        label: "ویرایش",
        icon: <img src={EditImg} alt="" />,
        onClick: editTransaction,
        show: true,
      },
      {
        Label: <span style={{ color: "#F42222", fontSize: "12px", fontWeight: 700 }}>حذف</span>,
        icon: <img src={DeleteImg} alt="" />,
        onClick: deleteTransaction,
        show: true,
      },
    ],
  };

  const details = [];
  transaction.date && details.push(`تاریخ ثبت: ${transaction.date}`);

  const typeTitle = () => {
    switch (transaction.type) {
      case "receive":
        return "دریافت";
      case "payment":
        return "پرداخت";
      case "income":
        return "درآمد";
      case "cost":
        return "هزینه";
      default:
        return "دریافت";
    }
  };
  const renderTable = (transaction: any) => {
    let source: any = [];
    let destination: any[] = [];

    transaction.Transaction_Items.map((item: any) => {
      const key =
        item.optionableType === "financial" ? item.optionType?.type : item.optionableType ?? "account";
      const rowTypes: any = {
        account: {
          type: "حساب",
          label: item.Account_Type?.title,
          description: item.description,
          price: Math.abs(item.amount),
        },
        person: {
          type: "شخص",
          label: item.optionType?.nickName,
          description: item.description,
          price: Math.abs(item.amount),
        },
        bank: {
          type: "بانک",
          label: item.optionType?.name,
          description: item.description,
          price: Math.abs(item.amount),
        },
        cashier: {
          type: "صندوق",
          label: item.optionType?.name,
          description: item.description,
          price: Math.abs(item.amount),
        },
        fund: {
          type: "تنخواه گردان",
          label: item.optionType?.name,
          description: item.description,
          price: Math.abs(item.amount),
        },
        cheque: {
          type: "چک",
          label: [item.optionType?.name, item.optionType?.bank, item.optionType?.dueDate]
            .filter((x) => x)
            .join(" - "),
          description: item.description,
          price: Math.abs(item.optionType?.amount),
        },
        spendCheque: {
          type: "خرچ چک",
          label: [item.optionType?.name, item.optionType?.bank, item.optionType?.dueDate]
            .filter((x) => x)
            .join(" - "),
          description: item.description,
          price: Math.abs(item.optionType?.amount),
        },
      };
      const row = rowTypes[key];
      // let side = ["account", "person"].includes(key) && item.amount > 0 ? "source" : "destination";
      // if (transaction.type === "payment" && key === "person" && item.amount > 0) side = "destination";
      // if (transaction.type === "payment" && key === "person" && item.amount < 0) side = "source";
      // if (transaction.type === "income" && item.amount < 0) side = "destination";
      // if (transaction.type === "cost" && key === "person" && item.amount > 0) side = "destination";
      // if (transaction.type === "cost" && key === "account" && item.optionableType === null) {
      //   side = "source"
      // }
      if (item.type === "source") {
        source.push(row);
      } else {
        destination.push(row);
      }


    });
    if (transaction.Factors?.length) {
      transaction.Factors.map((x: Factor) => {
        const amountFactor = transaction.Factor_Transactions.find((y: any) => y.FactorId === x.id).amount;
        if (transaction.type === "payment" || transaction.type === "cost") {
          destination.push({
            type: "شخص",
            label: x.Person.nickName,
            price: amountFactor,
            description: x.title
          });

        } else if (transaction.type === "income" || transaction.type === "receive") {
          source.push({
            type: "شخص",
            label: x.Person.nickName,
            price: amountFactor,
            description: x.title
          });
        }
      })
    }

    setTable({
      source: {
        ...initialTable,
        rows: source,
      },
      destination: {
        ...initialTable,
        rows: destination,
      },
    });
  };

  return (
    <div style={{ backgroundColor: "#FCFEFF", height: "100vh" }}>
      <Header heading={typeTitle()} id={`${transaction.accountingCode}`} />
      <Action
        actions={actions}
        side={
          <div>
            <Price price={transaction.amount} currency={transaction.Currency} />
          </div>
        }
        withReminder
        withPrint ={["payment","receive"].includes(transaction.type)}
        fireDate={undefined}
        submitNotification={(value) => {
          submitNotification(value);
        }}
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        handleOpenModal={handleOpenModal}
        deleteItem={(id) => handleDeleteNotification(id)}
        updateNotification={(val) => handelChangeActive(val)}
        reminderData={notificationsList}
      />

      <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
        <Tab label="خلاصه" {...a11yProps(0)} />
        <Tab label="تاریخچه" {...a11yProps(1)} />
      </Tabs>

      <TabPanel value={value} index={0}>
        <div style={{ padding: "0px 32px" }}>
          <Details details={details} />
          <Box>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
                <div style={{ display: "flex", gap: 20 }}>
                  <Info title="#" info={transaction.accountingCode} />
                  <Info title="عنوان تراکنش" info={transaction.description} />
                </div>
                <div style={{ display: "flex", gap: 20 }}>
                  {transaction?.Project && <Info title="پروژه" info={transaction.Project.title} />}
                  {transaction?.Branch && <Info title="شعبه" info={transaction.Branch.title} />}
                </div>
              </div>
            </div>
          </Box>
        </div>

        <div style={{ padding: "16px 32px" }}>
          <Info
            title={transaction.type === "cost" ? "پرداخت به" : transaction.type === "income" ? "دریافت از" : transaction.type === "receive" ? "دریافت از" : "پرداخت به"}
            info={""}
          />
          <Box>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "auto",
                position: "relative",
              }}
            >
              <Table {...table.source} />
            </div>
          </Box>
        </div>

        <div style={{ padding: "16px 32px" }}>
          <Info
            title={transaction.type === "cost" ? "مبدا پرداخت" : transaction.type === "income" ? "مقصد دریافت" : transaction.type === "receive" ? "مقصد دریافت" : "مبدا پرداخت "}
            info={""}
          />
          <Box>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "auto",
                position: "relative",
              }}
            >
              <Table {...table.destination} />
            </div>
          </Box>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DrawerHistory
          title={"تراکنش ها"}
          history={History}
          noteList={noteList}
          token={token}
          detail_type="Transaction"
          id={transaction.type_id ?? transaction.id}
          refresh={() => {
            initialNote();
          }}
        />
      </TabPanel>
      <PrintTransaction data={transaction} table={table} typeTitle={typeTitle()} />
    </div>
  );
}
